@defer (when user) {
  <article class="content-container">
    <div>
      <div>
        <span>Name </span>
        <input class="fourd" maxlength="50" [(ngModel)]="user.name" name="name" [class.in-error]="user.name?.length < 2 && inError" />
      </div>
      <div>
        <span>Email </span>
        <input type="email" class="fourd" maxlength="250" [(ngModel)]="user.email" name="email" [class.in-error]="user.email?.length < 10 && inError" />
      </div>
    </div>

    <div>
      <div>
        <span>Job Title </span>
        <div>
          <input class="fourd" maxlength="50" placeholder="optional" [(ngModel)]="user.job_title" name="job_title" />
        </div>
      </div>
    </div>

    <div>
      <div>
        <span>Notes </span>
        <div>
          <textarea class="fourd" maxlength="1000" rows="3" [(ngModel)]="user.notes" placeholder="optional" name="notes"></textarea>
        </div>
      </div>
    </div>

    <footer class="mb-1">
      <p>This contact is for email notifications and will be unable to login.</p>
      <div class="buttons">
        <div>
          @if (user.id) {
            <app-button [isDanger]="true" icon="mdi mdi-trash-can-outline" (click)="deleteContact()" label="Delete contact" />
          }
        </div>
        <div>
          <app-button icon="mdi mdi-close" class="mr-1" (click)="cancel()" label="Cancel" />
          <app-button [isCTA]="true" icon="mdi mdi-check" (click)="submitContact()" [label]="user.id ? 'Update contact' : 'Create contact'" />
        </div>
      </div>
    </footer>
  </article>
}
